module.exports = __webpack_public_path__ + "static/media/ArgentinianNights.36febea4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ArgentinianNights.ttf
// module id = 1633
// module chunks = 46